import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useEffect } from 'react';
import { BackButtonSimple } from '../../shared/back-button-simple';
import { Laptop } from '../../svgs';
import styles from './waiting-popup.module.css';

interface PopupProps {
  goBack: () => void;
  src: string;
}

export function WaitingPopup({ goBack, src }: PopupProps): ReactNode {
  useEffect(() => {
    const popup = window.open(
      src,
      '_blank',
      'width=1200,height=800,left=50,top=50,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,titlebar=no,toolbar=no'
    );

    return () => {
      popup?.close();
    };
  }, [src]);

  return (
    <div className={styles.wrapper} data-test-idnow-popup-placeholder>
      <div className={styles.container}>
        <div className="mb-32">
          <Laptop className={styles.icon} />
        </div>
        <h1 className="heading-section mb-16" data-test-idnow-started-on-popup-step-title>
          <FormattedMessage id="qonto-idnow.waiting-pop-up.title" />
        </h1>
        <p className="body-standard mb-32" data-test-idnow-started-on-popup-step-subtitle>
          <FormattedMessage id="qonto-idnow.waiting-pop-up.subtitle" />
        </p>
        <BackButtonSimple data-test-idnow-started-on-popup-step-go-back-btn onPress={goBack} />
      </div>
    </div>
  );
}
